const loading = (state) => state.loading
const loadingText = (state) => state.loadingText

export { loading }
export { loadingText }
